import type { DecryptedNotification } from "./storage-schema";

/** Prefer latestAndroidMsgId over card.msgId — Android FIFO-evicts originals (cap=500), so the latest tracker entry is more likely to still be present. Falls back to msgId if the card is absent or never updated. */
export function pickAndroidMsgId(
  msgId: string,
  notifications: DecryptedNotification[] | undefined
): string {
  const card = (notifications ?? []).find((n) => n.msgId === msgId);
  return card?.latestAndroidMsgId ?? msgId;
}
